import { getChartPalette } from "../theme";
import type { ChartContext } from "./context";

export function buildBubbleOption(
  context: ChartContext,
): Record<string, unknown> {
  const { data, isDark, translateNode, unitText, axisText, ct, base } = context;
  const ds = data.datasets[0];
  if (!ds) return base;
  return {
    ...base,
    tooltip: {
      trigger: "axis",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: (ps: Array<{ value: number[]; seriesName: string }>) =>
        ps
          .map(
            (p) =>
              `${translateNode(p.seriesName)}: ${unitText(p.value[1])} (${translateNode("size")}: ${p.value[2]})`,
          )
          .join("\n"),
    },
    xAxis: { type: "value", axisLabel: { color: ct.secondary } },
    yAxis: {
      type: "value",
      axisLabel: { color: ct.secondary, formatter: axisText },
      splitLine: { lineStyle: { color: ct.lightBorder } },
    },
    grid: { left: 60, right: 20, bottom: 40, top: 65, containLabel: true },
    series: data.datasets.map((s, i) => ({
      type: "scatter",
      name: s.label,
      data: (
        s.values as unknown as Array<{ x: number; y: number; z: number }>
      ).map((v) => [v.x, v.y, v.z]),
      symbolSize: (val: number[]) => Math.max(5, (val[2] ?? 10) / 5),
      itemStyle: {
        color: getChartPalette(isDark, data.datasets.length)[i],
      },
    })),
  };
}
